var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"sticky-wrapper",style:({height: _vm.height})},[_c('div',{staticClass:"sticky-box",class:_vm.classes,style:({left: _vm.left, width: _vm.width, top: _vm.top})},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }